<template>
  <jw-form-item :label-col-style="{ width: '120px' }" label-col-flex="auto">
    <template #label>
      <xl-label-text :value="$t('显示条件')" :row="1" />
    </template>
    <jw-select v-model="data.sendType.modules[0].display" popup-container=".layout-config-container" :trigger-props="{ updateAtScroll: true }" :placeholder="$t('请选择显示条件')" allow-search allow-clear @change="changeDisplay" :options="conditionSelectList" />
  </jw-form-item>
  <jw-form-item v-if="data.sendType.modules[0].display === 2" :label-col-style="{ width: '120px' }" label-col-flex="auto">
    <jw-button type="outline" v-if="!data.sendType.modules[0].displayConditions" long @click="emits('addCondition', data.sendType.modules[0].displayConditions, 4)">{{ $t('添加条件') }}</jw-button>
    <jw-button v-else type="outline" long @click="emits('addCondition', data.sendType.modules[0].displayConditions, 4)">{{ $t('tips.conditionsCount', { count: data.sendType.modules[0].displayConditions?.children?.length || 0 }) }}</jw-button>
  </jw-form-item>
  <!-- 字段配置 -->
  <template v-if="data.sendType.modules[0].display === 1 || data.sendType.modules[0].display === 2">
    <jw-form-item :label-col-style="{ width: '120px' }" label-col-flex="auto">
      <template #label>
        <xl-label-text :value="$t('展示字段')" :row="1" />
      </template>
      <jw-button :loading="loading" type="outline" long @click="tableFieldFollowSetting()">{{ getModulesLens(data.sendType.modules[0].modules) > 0 ? $t(`已配置：${getModulesLens(data.sendType.modules[0].modules)}个字段`) : $t('展示字段配置') }}</jw-button>
    </jw-form-item>
  </template>
  <!-- 字段配置 -->
  <field-config ref="tableFieldConfigRef" @cb="getFieldsCb" :empty="false" :freeze="true" :isClear="true" title="动态表格字段配置" />
</template>

<script setup>
import fieldConfig from '@/views/setting/sys-fields/page-layout/components/field-config/field-config.vue'; //字段配置
import { reactive, ref, toRef } from 'vue';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
import useViewFields from '@/hooks/view-fields';
import getLayoutFields from '@/hooks/layout';
const { enableList, getViewFields } = useViewFields();
const { getModulesLens, handleEnableFields, handleModules, originalModules } = getLayoutFields();
const emits = defineEmits(['updateData', 'addCondition']);
import useLoading from '@/hooks/loading';
const { loading, setLoading } = useLoading(false);

const props = defineProps({
  sendType: {
    type: Object,
    default: () => {}
  }
});

const conditionSelectList = [
  { value: 0, label: '默认不可见' },
  { value: 1, label: t('默认可见') },
  { value: 2, label: t('满足条件可见') }
];
const data = reactive({
  sendType: toRef(props, 'sendType')
});
const tableFieldConfigRef = ref();
// 改变显示条件
const changeDisplay = (v) => {
  data.sendType.modules.display = v;
  if (v == 0 || v == 1) {
    data.sendType.modules.displayConditions = null;
  }
  emits('updateData', data.sendType.modules);
};

// 获取对象所有字段
const getAllModules = async () => {
  setLoading(true);

  await getViewFields({ id: 16 });
  setLoading(false);
  enableList.value = handleEnableFields(enableList.value);

  await handleModules(enableList.value, data.sendType.modules[0].modules);
  data.sendType.modules[0]['original'] = originalModules.value;
};
// 表格字段配置(动态记录)
const tableFieldFollowSetting = async () => {
  if (!data.sendType.modules?.[0]?.original) {
    //请求字段
    await getAllModules();
  } else {
    await handleModules(enableList.value, data.sendType.modules[0].modules); //处理表格数据
    data.sendType.modules[0]['original'] = originalModules.value;
  }
  emits('updateData', data.sendType.modules);
  tableFieldConfigRef.value?.open(data.sendType.modules?.[0]['original']);
};

// 字段配置区条件回传
const getFieldsCb = (callbackModules) => {
  // 动态记录配置
  if (callbackModules) {
    data.sendType.modules[0]['original'] = callbackModules;
    //处理字段
    const getModules = callbackModules?.modules
      ?.filter((item) => item?.showField)
      ?.map((el) => {
        return {
          ...el,
          modules: el?.modules?.filter((subItem) => subItem?.showField)
        };
      });
    data.sendType.modules[0].modules = getModules;

    emits('updateData', data.sendType.modules);
  }
};
</script>
<style scoped lang="less">
@import './dynamics-config.less';
</style>
